module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/guide3-7280044466088d711584e3b63942686a.png";